import React, { useContext } from 'react';
import { NewCheckbox } from '../../../checkbox/checkbox';
import { TableSettingsContext } from '../../table-settings-context';
export const HeaderCheckbox = ({ indeterminate, checked, ...props }) => {
    const { checkboxType } = useContext(TableSettingsContext);
    return (React.createElement(NewCheckbox, { ...props, checked: checked || indeterminate, indeterminate: indeterminate, filled: checkboxType === 'filled', ariaLabel: "Header checkbox" }));
};
